import { RailItemCard } from "@/components/home/RailItemCard";
import { RailScroller } from "@/components/home/RailScroller";
import { RAIL_COLUMN, SectionRail } from "@/components/home/SectionRail";
import {
  railCardShrinkRem,
  STOREFRONT_SECTION_LABELS,
  type StorefrontSection,
} from "@/domain/storefront-appearance";
import { useItemModalParam } from "@/hooks/use-item-modal-param";
import { useRailCardWidth } from "@/hooks/use-rail-metrics";
import {
  useSectionItemOffers,
  type ItemRailSectionKey,
} from "@/hooks/use-section-item-offers";

/**
 * Horizontal menu-item rail — promotions, featured, bestsellers. One component
 * for all three; they differ only in the LIST from `useSectionItemOffers`.
 * Renders nothing without items. `visible` is permission, not obligation.
 */
export function ItemOffersRail({ section }: { section: StorefrontSection }) {
  const { rounded: corners } = section;
  const itemOffers = useSectionItemOffers(section.key as ItemRailSectionKey);
  const { openItem } = useItemModalParam();

  const { railRef, cardWidth } = useRailCardWidth({
    size: section.size,
    shrinkRem: railCardShrinkRem(section.size, section.imageVisible),
  });

  if (itemOffers.length === 0) return null;

  return (
    <SectionRail
      label={STOREFRONT_SECTION_LABELS[section.key].label}
      titleCard={section.titleCard}
    >
      <RailScroller
        className={RAIL_COLUMN}
        rootRef={railRef}
        watch={`${itemOffers.length}:${cardWidth ?? ""}`}
      >
        <ul className="flex gap-3 pb-1 snap-x">
          {itemOffers.map((itemOffer) => (
            <li key={itemOffer.id} className="snap-start shrink-0">
              {cardWidth !== null && (
                <RailItemCard
                  itemOffer={itemOffer}
                  size={section.size}
                  rounded={corners}
                  imageVisible={section.imageVisible}
                  width={cardWidth}
                  onClick={openItem}
                />
              )}
            </li>
          ))}
        </ul>
      </RailScroller>
    </SectionRail>
  );
}
